module.exports = __webpack_public_path__ + "static/media/contactless-delivery.db00b38b.png";